"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSegmentActiveStyles = exports.GetLabelHoverStyles = exports.getFocusStyles = void 0;
const theme_1 = require("@icr-ui/theme");
const styled_components_1 = require("styled-components");
const styles_1 = require("./styles");
const getFocusStyles = (background) => `
  position: relative;
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: ${background};
    width: 100%;
    height: 2px;
  }
`;
exports.getFocusStyles = getFocusStyles;
const GetLabelHoverStyles = (isActive) => {
    return (0, styled_components_1.css) `
    ${styles_1.StyledSegmentText} {
      color: ${theme_1.primary.dark};
      font-weight: 500;
    }
    ${isActive && (0, exports.getFocusStyles)(theme_1.primary.dark)}
  `;
};
exports.GetLabelHoverStyles = GetLabelHoverStyles;
const GetSegmentActiveStyles = (isActive) => {
    if (isActive) {
        return (0, styled_components_1.css) `
      ${styles_1.StyledSegmentText} {
        color: ${theme_1.primary.light};
        font-weight: 500;
      }
      ${(0, exports.getFocusStyles)(theme_1.primary.light)}
    `;
    }
};
exports.GetSegmentActiveStyles = GetSegmentActiveStyles;
//# sourceMappingURL=utils.js.map